import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { nullish } from '../../shared/types/nullish.ts';


interface Props {
    isLoggedIn: boolean | nullish;
}

export function useRedirectToLogin({
    isLoggedIn
}: Props) {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (isLoggedIn === false) {
            const currentPath = location.pathname + location.search + location.hash;
            navigate('/login', {
                replace: true,
                state: { from: currentPath }
            });
        }
    }, [isLoggedIn, location.pathname, location.search, location.hash, navigate]);
}
